/**
 * FakeDropdown - styled non-native dropdown used by option pickers.
 * Custom element: <fake-dropdown>
 *
 * Refs:
 *   [data-ref="target"]  (required)
 *   [data-ref="selectedOption"]  (required)
 *   [data-ref="option"]  (required)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { dist } from "./vendor.js";
import { ThemeComponent } from "./theme.js";
class FakeDropdown extends ThemeComponent {
  constructor() {
    super(...arguments), this._onChange = new dist.SimpleEventDispatcher();
  }
  get onChange() {
    return this._onChange.asEvent();
  }
  init() {
    if (this.$listen(this.target, "click", () => this.toggleVisibility()), this.option) for (const optionElement of this.option) this.$listen(optionElement, "click", () => this.handleOptionSelect(optionElement));
    this.$listen(document.body, "click", bodyClickEvent => {
      const clickedElement = bodyClickEvent.target;
      clickedElement != null && clickedElement.closest(".fake-dropdown") || this.close();
    });
  }
  toggleVisibility() {
    this.classList.toggle("is-active");
  }
  handleOptionSelect(selectedElement) {
    const selectedValue = selectedElement.getAttribute("data-value"),
      selectedLabel = selectedElement.textContent;
    selectedValue && (this._onChange.dispatch(selectedValue), this.selectedOption.textContent = selectedLabel);
    for (const otherOption of this.option) otherOption.classList.remove("fake-dropdown__option--selected");
    selectedElement.classList.add("fake-dropdown__option--selected"), this.toggleVisibility();
  }
  close() {
    this.classList.remove("is-active");
  }
}
setFunctionName(FakeDropdown, "FakeDropdown");
const propertyTypes = {};
FakeDropdown.prototype.$name = "FakeDropdown";
FakeDropdown.prototype.$info = JSON.parse('{"name":"FakeDropdown","meta":{"isLegacy":false,"selector":"fake-dropdown"},"props":[],"refs":[{"selector":"[data-ref=\\"target\\"]","required":true,"propertyKey":"target","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"},{"selector":"[data-ref=\\"selectedOption\\"]","required":true,"propertyKey":"selectedOption","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLSpanElement"},{"selector":"[data-ref=\\"option\\"]","required":true,"propertyKey":"option","propertyType":"Array","propertyTypeName":"Array","propertyTsTypeName":"HTMLButtonElement[]"}]}');
FakeDropdown.prototype.$info.component = FakeDropdown;
for (const prop of FakeDropdown.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("FakeDropdown/FakeDropdown.ts", {
  FakeDropdown: FakeDropdown
}, void 0);